import { render, staticRenderFns } from "./CBBG1010.vue?vue&type=template&id=10d20a90&scoped=true"
import script from "./CBBG1010Controller.ts?vue&type=script&lang=ts&external"
export * from "./CBBG1010Controller.ts?vue&type=script&lang=ts&external"
import style0 from "./CBBG1010.vue?vue&type=style&index=0&id=10d20a90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d20a90",
  null
  
)

export default component.exports